module.exports = __webpack_public_path__ + "static/media/icon-link-dark.e6efd6db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-link-dark.svg
// module id = 523
// module chunks = 0